import { create } from 'zustand';

const useMailTemplateStore = create((set) => ({
  // State
  mailTemplates: [],
  loading: false,
  error: null,

  // Pagination State
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  // Filter & Search State
  columnFilters: {},
  uniqueValues: {},

  // UI State
  selectedMailTemplate: null,
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  mailTemplateToDelete: null,

  // Actions
  setMailTemplates: (mailTemplates) => set({ mailTemplates }),

  setPagination: (paginationData) => set((state) => ({
    paginationData: { ...state.paginationData, ...paginationData }
  })),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // Filter Actions
  setColumnFilters: (filters) => set((state) => {
    return {
      columnFilters: typeof filters === 'function' ? filters(state.columnFilters) : filters
    };
  }),

  setUniqueValues: (values) => set((state) => ({
    uniqueValues: { ...state.uniqueValues, ...values }
  })),

  // Form Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedMailTemplate: null
  }),

  openEditForm: (mailTemplate) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedMailTemplate: mailTemplate
  }),

  closeForm: () => set({
    isFormOpen: false,
    isEditMode: false,
    selectedMailTemplate: null
  }),

  // Dialog Actions
  openDeleteDialog: (mailTemplate) => set({
    isDeleteDialogOpen: true,
    mailTemplateToDelete: mailTemplate
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    mailTemplateToDelete: null
  }),

  // Reset
  reset: () => set({
    mailTemplates: [],
    loading: false,
    error: null,
    columnFilters: {},
    selectedMailTemplate: null,
    isFormOpen: false,
    isDeleteDialogOpen: false
  })
}));

export { useMailTemplateStore };
export default useMailTemplateStore;
